import { ProgressSpinner } from 'primereact/progressspinner'
import { FC, useEffect, useState } from 'react'
import { downloadFileDirectFromBlob } from '../../../services/blobUploadService'
import { UploadTypes } from '../../../utils/constants'

// Geometry-change images live in the cfd-data container, which the browser cannot
// reach directly. Fetch the bytes through the DownloadBlobProxy and render them
// from an object URL rather than loading the source SAS URL in an <img> tag.
const GeometryProxyImage: FC<{
  blobPath?: string
  gmid?: string
  alt?: string
  className?: string
}> = ({ blobPath, gmid, alt, className }) => {
  const [src, setSrc] = useState('')
  const [failed, setFailed] = useState(false)

  useEffect(() => {
    if (!blobPath) {
      setFailed(true)
      return
    }
    let objectUrl = ''
    let cancelled = false
    downloadFileDirectFromBlob(
      async () => '',
      UploadTypes.GEOMETRY_CHANGE_FILE,
      blobPath,
      null,
      gmid
    )
      .then(blob => {
        if (cancelled) return
        objectUrl = URL.createObjectURL(blob)
        setSrc(objectUrl)
      })
      .catch(() => {
        if (!cancelled) setFailed(true)
      })
    return () => {
      cancelled = true
      if (objectUrl) URL.revokeObjectURL(objectUrl)
    }
  }, [blobPath, gmid])

  if (failed) {
    return (
      <div className="w-full h-full flex items-center justify-center bg-gray-100 dark:bg-neutral-70 text-[10px] text-gray-400">
        Unavailable
      </div>
    )
  }
  if (!src) {
    return (
      <div className="w-full h-full flex items-center justify-center bg-gray-100 dark:bg-neutral-70">
        <ProgressSpinner style={{ width: '1.25rem', height: '1.25rem' }} strokeWidth="6" />
      </div>
    )
  }
  return (
    <img
      src={src}
      alt={alt}
      className={className ?? 'w-full h-full object-cover'}
      draggable={false}
    />
  )
}

export default GeometryProxyImage
